//--------------------------------------------------------------------//
//******************** deployment manager request helpers *************//
//--------------------------------------------------------------------//
// Shared low-level fetch helper for talking to the deployment-manager
// server's POST endpoints (create/update/delete/pull/deploy/kill), which
// take the token as a gudhub_token body field. The GET endpoints
// (list/getOne/logs) send it as an Authorization header instead — see
// deployments.service.js, which calls getAuthData() directly for those.
import { GUDHUB_SETTINGS } from '../../config.js';

// Retrieves current user auth data (token, user_id, auth_key) for API requests.
export async function getAuthData() {
    const token = await gudhub.getToken();
    const user = gudhub.storage.getUser();

    return {
        token,
        user_id: user.user_id,
        auth_key: user.auth_key
    };
}

// Sends an authenticated request to the deployment-manager server.
// The backend's field name for the caller's GudHub token is `gudhub_token`
// (not `access_token` like the agents server expects) — it forwards this
// token as-is to gudhub-git-repo to provision/revoke SSH access.
export async function request(endpoint, data = {}, method = 'POST') {
    const authData = await getAuthData();
    const url = GUDHUB_SETTINGS.deployment_manager_server_url + endpoint;

    const options = {
        method,
        headers: { 'Content-Type': 'application/json' }
    };

    if (method !== 'GET') {
        options.body = JSON.stringify({
            ...data,
            gudhub_token: authData.token
        });
    }

    const response = await fetch(url, options);
    const result = await response.json();

    if (!response.ok) {
        throw new Error(result.error || result.message || 'Deployments service request error');
    }

    return result;
}
